module.exports = __webpack_public_path__ + "static/media/muinas.d882c0f7.png";